import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_2 = { class: "title d-flex" }
const _hoisted_3 = { class: "d-flex align-items-center position-relative me-2" }
const _hoisted_4 = { class: "svg-icon svg-icon-3 position-absolute ms-3" }
const _hoisted_5 = { class: "toolbars" }
const _hoisted_6 = { class: "w-50px" }
const _hoisted_7 = { class: "w-50px" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex py-2 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold me-2" }, "Encontrados", -1)
const _hoisted_13 = { class: "badge badge-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DialogForms = _resolveComponent("DialogForms")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: `${_ctx.itemForm?.form_name} - Lista de instituciones`,
      modelValue: _ctx.dialogListClubs,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogListClubs) = $event)),
      "close-on-click-modal": false,
      class: "bg-light rounded",
      top: "2vh",
      fullscreen: true,
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                type: "text",
                class: "form-control form-control-white form-control-sm w-300px ps-9",
                placeholder: "Buscar",
                maxlength: "100"
              }, null, 512), [
                [_vModelText, _ctx.search]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "m-0"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Agregar")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              color: "#E71D2E",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'forms/f1', { a: _ctx.mbtoa(_ctx.itemForm.idevent) })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Descargar ")
              ]),
              _: 1
            })
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.filteredClubs,
          stripe: "",
          border: "",
          class: "w-100 align-middle",
          style: {"width":"100%"},
          height: _ctx.altura - 290,
          "table-layout": 'auto'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              align: "center",
              "class-name": "border text-center align-middle fw-bold",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "abrev",
              label: "SIGLAS",
              align: "center",
              "class-name": "border text-center align-middle fw-bold",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(row.abrev), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "",
              prop: "business",
              label: "INSTITUCION",
              align: "center",
              "class-name": "border align-middle fw-bold",
              width: "350"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", {
                  class: "w-350px text-hover hover-primary",
                  onClick: ($event: any) => (_ctx.openDialogForm(row.idinstitution))
                }, _toDisplayString(row.business), 9, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "mstatus",
              label: "ESTADO",
              align: "center",
              "class-name": "border text-center align-middle fw-bold"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(`${row?.mstatus.params} text-white rounded px-2 py-1`),
                  style: {"font-size":"11px"}
                }, _toDisplayString(row?.mstatus?.name), 3)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSports, (sport, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: `isport-${index}-a`,
                label: sport.name,
                align: "center",
                "class-name": "border text-center align-middle fw-bold"
              }, {
                default: _withCtx(({ row }) => [
                  (_ctx.isSelected(sport.idsport, row.sports))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "X"))
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              label: "Total",
              align: "center",
              fixed: "right",
              "class-name": "border text-center align-middle fw-bold",
              "cell-style": { backgroundColor: '#000' }
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(_ctx.calculateTotal(row.sports)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "height"])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.listInstitutions.length), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_DialogForms, {
      "item-form": _ctx.itemForm,
      idevent: _ctx.itemForm.idevent,
      onModalClosed: _ctx.modalClosed
    }, null, 8, ["item-form", "idevent", "onModalClosed"])
  ], 64))
}